<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/j36GC9/tc-custom/9781504064781.jpg?1705025862343" alt="This image is the cover for the book October"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">October
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A bullied teen mistakenly summons a powerful demon in this dark fantasy for fans of Robert R. McCammon by the author of <i>Enter, Night</i>.</b></p><p>Dark secrets run deep in the isolated, rural town of Auburn, Ontario. But everyone knows about Mikey Childress.</p><p>Sixteen-year-old Mikey isn’t like the other boys, who play hockey and chase girls. He’s skinny, wears black, reads horror novels, listens to Madonna, and idolizes Hollywood actresses. He’s “different,” and the bullies at school won’t let him forget it. Only his best friend, Wroxy, has any idea of the depths of Mikey’s pain and how desperately he desires to be loved.</p><p>And not even Wroxy knows what Mikey’s truly capable of—until one night when his abusers go too far. Then all the pain and loneliness inside Mikey push him to make a pact with evil to bring vengeance down upon his enemies. Being a teenager had been a nightmare before, but soon Mikey unleashes something that will make it hell on Earth . . .</p><p>“Rowe’s talent shines through in this terrifying story of social persecution, black magic, and desire gone horribly wrong.” —Lee Thomas, Bram Stoker and Lambda Literary Award–winning author</p> “Michael Rowe is one of those writers who can swing from the eloquent prose of a Peter Straub to the brutality of a Richard Laymon.” —<i>Monster Librarian</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Rowe
      </h2>
      
      <p class="authorDescription body article">Michael Rowe was born in Ottawa, and has lived in Beirut, Havana, Geneva, and Paris. He is the author of the novels&#160;<I>Enter, Night</I>;<I>&#160;Wild Fell</I>; and&#160;<I>October</I>; and created and edited the anthologies&#160;<I>Queer Fear</I>&#160;and&#160;<I>Queer Fear 2</I>. An award-winning journalist and essayist, Rowe is also the author of the nonfiction books&#160;<I>Writing Below the Belt</I>,<I>&#160;Looking for Brothers</I>, and&#160;<I>Other Men&rsquo;s Sons.&#160;</I>He has won the Lambda Literary Award, the New Millennium Writing Award, and the Publishing Triangle Award; and was a finalist for the National Magazine Award, the International Horror Guild Award, the Sunburst Award, and the Shirley Jackson Award. Rowe lives in Toronto and welcomes readers at&#160;www.michaelrowe.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59e43737